<template>
  <!-- <div v-show="requireLoading" class="loader-wrapper" v-if="loading">
    <div class="loader-index"><span></span></div>
    <svg>
      <defs></defs>
      <filter id="goo">
        <fegaussianblur in="SourceGraphic" stddeviation="11" result="blur"></fegaussianblur>
        <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"> </fecolormatrix>
      </filter>
    </svg>
  </div> -->
  <div class="d-flex flex-column" style="min-height: 100vh">
    <div v-if="!$route.meta.hideHeader">
      <Header v-show="requireSideIcons" />
    </div>
    
    <div class="flex-grow-1">
      <div class="row">
        <div v-if="!$route.meta.hideSideIcons">
          <div v-show="requireSideIcons" style="min-height: 100%;">
            <SideNav class="h-100" />
          </div>
        </div>
        <div class="col-12">
          <router-view />
        </div>
      </div>
    </div>
    <div v-if="!$route.meta.hideFooter">
      <FooterComponent v-show="requireSideIcons" />
    </div>
    <div v-show="requireToTopBtn">
      <img src="@/assets/icons/Jump-to-top.png" id="btnTop" v-if="!$route.meta.hideToTopBtn" class="click-to-top" alt="">
    </div>

  </div>
</template>

<script>
import Header from "./components/TopHeader.vue";
import SideNav from "./components/SideNav.vue";
import FooterComponent from "./components/FooterComponent.vue";

export default {
  name: 'App',
  components: {
    Header,
    SideNav,
    FooterComponent,
  },
  data() {
    return {
      loading: true,
      requireSideIcons: false,
      requireLoading: false,
      requireLoading: false,
      requireToTopBtn: false,
    }
  },
  watch: {
    '$route'(newRoute) {
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000)
      this.loading = !this.loading
      if (newRoute && newRoute.name) {
        this.requireSideIcons = newRoute.name.startsWith('admin-') ? false : true;
        this.requireToTopBtn = newRoute.name.startsWith('admin-') ? false : true;
      }

      if (newRoute && newRoute.name) {
        this.requireLoading = newRoute.name.startsWith('admin-')
      }
    }
  },


  mounted() {
    this.loading = false;

    window.addEventListener('scroll', () => this.handleScroll(this.$route));
    document.getElementById('btnTop').addEventListener('click', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll(route) {
      var btnTop = document.getElementById('btnTop');
      var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      if (!route.meta.hideToTopBtn && scrollPosition > 200) {
        btnTop.style.display = 'block';
      } else if (route.meta.hideToTopBtn) {
        //hide the btnTop.style.display here to avoid error
      } else {
        btnTop.style.display = 'none';
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
  },
}

</script>

<style>
@import "@/assets/css/main.css";

.footer {
  margin-top: auto;
}

.topBar {
  margin: 0 20px;
}

.click-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
  width: 4rem;
  border-radius: 10%;
  cursor: pointer;

  
}
</style>
